import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';

/**
 * Resolved related records for a location activity event, keyed by relation.
 */
export class LocationActivityEventHydration {
  link?: ActivityLinkHydration;
}
